function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, runInAction } from "mobx";
import IonResource from "terriajs-cesium/Source/Core/IonResource";
/**
 * A mixin for a model that can be loaded from Cesium ion via an `ionAssetId`. If an asset ID is supplied,
 * the `ionResource` will be populated asynchronously after `loadIonResource` is called (usually from
 * `forceLoadMetadata`). If defined, the resource in this property should be used as the "URL" given to
 * CesiumJS instead of a regular URL.
 */
export default function CesiumIonMixin(Base) {
  var _class, _descriptor;
  let CesiumIonMixin = (_class = class CesiumIonMixin extends Base {
    constructor() {
      super(...arguments);
      /**
       * The {@link IonResource} that can be given to CesiumJS most places that a resource URL can be used.
       */
      _initializerDefineProperty(this, "ionResource", _descriptor, this);
    }
    /**
     * Populates the the `ionResource` from the `ionAssetId`, `ionAccessToken`, and `ionServer`
     * traits. This should be called from `forceLoadMetadata`.
     */
    async loadIonResource() {
      if (this.ionAssetId) {
        const resource = await IonResource.fromAssetId(this.ionAssetId, {
          accessToken: this.ionAccessToken,
          server: this.ionServer
        });
        runInAction(() => {
          this.ionResource = resource;
        });
      } else {
        this.ionResource = undefined;
      }
    }
  }, _descriptor = _applyDecoratedDescriptor(_class.prototype, "ionResource", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return undefined;
    }
  }), _class);
  return CesiumIonMixin;
}